<template slot-scope="scope">
  <div>
    <!-- 知识产权服务上传 弹窗 -->
        <dialogModel
          width="900px"
        title="提交多项"
          :visible="VisibleUp"
          @handleClose="handleClose"
          @handleOk="handleConfirm"
        >
          <div class="main-body">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="148px"
                class="demo-ruleForm"
              >
                <el-form-item label="服务类型：" prop="Business" :required="true">
                <el-radio-group
                  v-model="ruleForm.Business"
                  @change="handelBusiness"
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'svc-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
                <el-form-item label="支付方式：">
                <el-radio-group v-model="payType">
                  <el-radio
                    v-for="item in payTypeArr"
                    :key="'pay-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
                <el-form-item label="上传：" required class="upload-item">
                  <div class="upload-box">
                    <ImportRes
                      :url="UploadUrl"
                      :Switch="ruleForm.Business"
                      :ChangeParameters="2"
                      :type="11"
                      :ClearAll="ClearAll"
                      @handleOkImport="handleOkImport"
                      @handleClose="handleClose"
                      @handleClearOut="handleClearOut"
                    @upload-status="onUploadStatus"
                    ></ImportRes>
                    <div class="upload-tip">（上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）</div>
                  </div>
                </el-form-item>
              <div class="Price" v-if="priceVo.trademarkCount != null">
                <div>
                  商标数量：<span style="color: #ffa200"
                    >{{ priceVo.trademarkCount }}条</span
                  >
                </div>
                <div>
                  商标总价：<span style="color: #ffa200"
                    >{{ priceVo.trademarkAmount }}元</span
                  >
                </div>
              </div>
              <div class="Price" v-if="priceVo.copyrightCount != null">
                <div>
                  著作权(申请)数量：<span style="color: #ffa200"
                    >{{ priceVo.copyrightCount }}条</span
                  >
                </div>
                <div>
                  著作权(申请)总价：<span style="color: #ffa200"
                    >{{ priceVo.copyrightAmount }}元</span
                  >
                </div>
              </div>
              <div class="Price" v-if="priceVo.patentCount != null">
                <div>
                  专利数量：<span style="color: #ffa200"
                    >{{ priceVo.patentCount }}条</span
                  >
                </div>
                <div>
                  专利总价：<span style="color: #ffa200"
                    >{{ priceVo.patentAmount }}元</span
                  >
                </div>
              </div>
              <div class="Price" v-if="priceVo.totalAmount != null">
                <div>
                  总价：<span style="color: #fe574a"
                    >{{ priceVo.totalAmount }}元</span
                  >
                </div>
              </div>
            </el-form>
        </div>
      </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="14"
      :queryType="'proxy'"
        @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {
  pay, //支付接口
} from "../../../../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../../Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import ImportRes from "../IndexCom/ImportRes.vue";
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD } from "@/utils/paymentMethods";
export default {
  props: {
    VisibleUp: {},
    options1: {}, //平台企业的客户
    enterprise: {}, //平台企业的信息
  },
  components: { ImportRes, CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择 //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",

      Arr: [
        {
          id: 0,
          name: "商标",
          select: true,
        },
        {
          id: 1,
          name: "著作权(申请)",
          select: false,
        },
        {
          id: 2,
          name: "专利",
          select: false,
        },
      ], //上传弹窗 服务类型选项
      ruleForm: {
        Business: null, // 与新设立一致：先选类型再上传
      },
      rules: {
        // 规则未完善
        Business: [
          {
            required: true,
            message: "请选择上传类型",
            trigger: ["blur", "change"],
          },
        ],
      },
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证
      // trademarkList: [
      //   {
      //     orderCompanyName: "马锋公司", //需办理企业名称
      //     orderCreditCode: "411323199704063413", //统一社会信用代码
      //     orderLegalPerson: "mafeng", //法人姓名
      //     orderCompanyPhone: "18237742511", //联系电话
      //     itemType: 0, //图标类型 0 名称 1图标
      //     itemContent: "名称", //名称/图片地址
      //     orderTaxType: 0, //纳税类型0 小规模 1一般纳税人
      //     orderCompanyType: 0, //服务类别0有限公司/1个体户/2子公司/3分公司/4其他
      //     operationType: 0, //服务类型 0申请 1展期
      //     businessScope: "经营范围-啥都干，啥都干", //经营范围
      //     remark: "备注",
      //   },
      // ],
      trademarkList: [],
      copyrightList: [],
      patentList: [],
      priceVo: {}, //上传资料返回的价格数量
      UploadUrl: "",
      ClearAll: false,
      uploading: false,
    };
  },
  watch: {
    VisibleUp: {
      handler(newSs, old) {
        if (newSs == false) {
          this.trademarkList = [];
          this.copyrightList = [];
          this.patentList = [];
          this.priceVo = {}; //上传资料返回的价格数量
          this.ClearAll = true;
          this.ruleForm = {
            Business: null,
          };
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 10);
        } else {
          this.ClearAll = false;
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.UploadUrl = "/global/proxy/iprUpload";
  },

  methods: {
    onUploadStatus(status) {
      this.uploading = !!status;
    },
    //点击已上传文件后方的x
    handleClearOut() {
      this.trademarkList = [];
      this.copyrightList = [];
      this.patentList = [];
      this.priceVo = {}; //上传资料返回的价格数量
    },
    handelBusiness(id) {
      this.ClearAll = true;
      this.ruleForm.Business = id;
      this.$refs.ruleForm.validateField("Business");
        this.trademarkList = [];
        this.copyrightList = [];
        this.patentList = [];
        this.priceVo = {}; //上传资料返回的价格数量
      setTimeout(() => {
        this.ClearAll = false;
      }, 500);
    },
    // 上传完成
    handleOkImport(res) {
      const data = (res && res.data && res.data.data) || {};
      this.priceVo = data.iprPriceVo || data.priceVo || {};
      if (this.ruleForm.Business == 0) {
        this.trademarkList = data.trademarkList || [];
      } else if (this.ruleForm.Business == 1) {
        this.copyrightList = data.copyrightList || [];
      } else {
        this.patentList = data.patentList || [];
      }
      const hasData =
        (this.ruleForm.Business == 0 && this.trademarkList.length > 0) ||
        (this.ruleForm.Business == 1 && this.copyrightList.length > 0) ||
        (this.ruleForm.Business == 2 && this.patentList.length > 0);
      if (!hasData) {
        this.$tool.PromptBox("error", "上传文件解析为空请重新上传");
        // 仅提示，不清空上传组件，避免先错后对时把新选文件冲掉；再次选择会走替换上传
      }
    },
    // 选择开户类型
    handelClick(item) {
      item.select = !item.select;
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    // 确认
    handleConfirm() {
      if (this.uploading) {
        this.$tool.PromptBox("warning", "文件上传中，请稍候再确认");
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (
            (this.trademarkList.length > 0 && this.ruleForm.Business == 0) ||
            (this.copyrightList.length > 0 && this.ruleForm.Business == 1) ||
            (this.patentList.length > 0 && this.ruleForm.Business == 2)
          ) {
            if (localStorage.getItem("PaymentPwd") == "false") {
              //没有开启支付密码验证直接弹支付二维码
              this.handleUnderstandPwd();
            } else {
              // 支付密码验证
              this.VisiblePwd = true;
            }
          } else {
            this.$tool.PromptBox(
              "error",
              "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空"
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      if (this.ruleForm.Business == 0) {
        var data = {
          data: {
            businessType: "IPR",
            payMethod: this.payType,
            password: pwd,
            businessInfo: {
              buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
              buyCompanyName: this.enterprise.companyName, //下单企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //统一代码
              buyCompanyPhone: this.enterprise.phone, //企业电话
              trademarkList: this.trademarkList,
            },
          },
        };
      } else if (this.ruleForm.Business == 1) {
        var data = {
          data: {
            businessType: "IPR",
            payMethod: this.payType,
            password: pwd,
            businessInfo: {
              buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
              buyCompanyName: this.enterprise.companyName, //下单企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //统一代码
              buyCompanyPhone: this.enterprise.phone, //企业电话
              copyrightList: this.copyrightList,
            },
          },
        };
      } else {
        var data = {
          data: {
            businessType: "IPR",
            payMethod: this.payType,
            password: pwd,
            businessInfo: {
              buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
              buyCompanyName: this.enterprise.companyName, //下单企业名称
              buyCreditCode: this.enterprise.customerCreditCode, //统一代码
              buyCompanyPhone: this.enterprise.phone, //企业电话
              patentList: this.patentList,
            },
          },
        };
      }

      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false;
          console.log(res.data);
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;

          // this.$emit("handleConfirmUp");
          // 打开二维码弹窗
          this.VisiblePayment = true;
        } else {
          this.VisiblePwd = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../Bookkeeping/components/bookkeeping-form-dialog.less";

/deep/ .el-radio-group {
  flex-wrap: wrap;
  white-space: normal;
}
.Price {
  width: 100%;
  min-height: 30px;
  line-height: 30px;
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
  font-weight: 600;
  padding-left: 148px;
  box-sizing: border-box;
  > div {
    color: #fe574a;
    margin-right: 50px;
  }
}
</style>
